import { ClienteFincaLoteResponse } from "../../../../../modulos/terceros/response/ClienteFincaLoteResponse";
import { BaseMapRender, PopupConfig } from "../../../../base/map/BaseMapRender";
import { Tooltip } from "../../../../implementations/map/TooltipRender";
import { ConfigTopActions } from "../../../../implementations/map/TopActions";

export class AgriculturaMapRender extends BaseMapRender<ClienteFincaLoteResponse> {
  protected doInitData(): Promise<ClienteFincaLoteResponse[]> {
    return Promise.resolve([]);
  }

  protected doGetResponse(
    lote: ClienteFincaLoteResponse,
    _responseList: ClienteFincaLoteResponse[],
  ): ClienteFincaLoteResponse | null {
    return lote;
  }

  protected doDispose(): void {}

  protected getConfigTopActions(): ConfigTopActions<ClienteFincaLoteResponse> {
    const toolTipItems: Tooltip<ClienteFincaLoteResponse>[] =
      this.getDefaultTooltipItems();
    toolTipItems.push({
      get(_response, lote) {
        return lote.cultivo?.nombre ?? "-";
      },
      key: "cultivo",
      label: "Cultivo",
    });
    return {
      toolTipItems: toolTipItems,
      withConteo: true,
      withOrtomosaico: true,
    };
  }

  protected getPopupConfig(): PopupConfig<ClienteFincaLoteResponse> | null {
    const this_ = this;
    return {
      bindItems(lote, _response) {
        const items = this_.getDefaultPopupItems(lote);
        items.push({
          content: lote.cultivo?.nombre ?? "-",
          label: "Cultivo",
        });
        return items;
      },
      withEditLote: true,
    };
  }
}
